import React from "react";
import { useTranslation } from "react-i18next";
import { Title } from "@mantine/core";

export default function Dashboard() {
  const { t } = useTranslation();
  return (
    <div>
      <Title order={3}>{t("dashboard")}</Title>
    </div>
  );
}
